<ng-container *ngIf="lineSwitcherState$ | async as state">
    <bs-line-switcher-dialog-header [title]="messages.swapYourSelection"></bs-line-switcher-dialog-header>

    <div *ngIf="!hasError(state); else error" [ngClass]="{ 'line-switcher-dialog__content--empty': hasError(state) || !event }">
        <ng-container *ngIf="isLineSwitcherPick(state)">
            <bs-line-switcher-dialog-sport [event]="event" [optionGroup]="optionGroup" [pick]="pick" [tracking]="tracking">
            </bs-line-switcher-dialog-sport>
        </ng-container>
    </div>

    <ng-template #error>
        <p class="line-switcher-dialog__error">{{ state.errorState.message }}</p>
    </ng-template>

    <div class="line-switcher-dialog__footer">
        <div class="line-switcher-dialog__winnings" *ngIf="optionGroup && !hasError(state)">
            <div class="line-switcher-dialog__boosted-winnings" *ngIf="state.possibleWinningsState.boostedWinnings">
                {{ state.possibleWinningsState.title }}:
                <b class="original-winnings">{{ state.possibleWinningsState.winnings }}</b>
                <b>{{ state.possibleWinningsState.boostedWinnings }}</b>
            </div>
            <div class="line-switcher-dialog__regular-winnings" *ngIf="!state.possibleWinningsState.boostedWinnings">
                {{ state.possibleWinningsState.title }}: <b>{{ state.possibleWinningsState.winnings }}</b>
            </div>
        </div>

        <bs-line-switcher-swap-button
            [event]="event"
            [hasError]="hasError(state)"
            [buttonState]="state.swapButtonState"></bs-line-switcher-swap-button>
    </div>
</ng-container>
